import React from 'react'
import { Drawer } from 'antd'
import classes from './index.module.scss'
import { isMobile } from 'utils/basic'
import FOModal from 'components/FOModal/index'
import cancelIcon from 'static/img/ic-close.svg'
import { useI18n } from 'contexts/AuthContext'

const TakePhoneDrawer = ({
  visible,
  onClose,
  onTakePhoto,
  onSelectFromLibrary,
}) => {
  const mobile = isMobile()
  const { i18n } = useI18n()
  if (mobile) {
    return (
      <Drawer
        placement='bottom'
        onClose={onClose}
        open={visible}
        height='auto'
        rootClassName={classes.takePhoneDrawer}
        closable={false}
        maskClosable={true}
        destroyOnClose={true}
        title={null}
      >
        <div className={classes.container}>
          <div className={classes.optionsContainer}>
            <div className={classes.optionItem} onClick={onTakePhoto}>
              <span className={classes.optionText}>{i18n('Take photo')}</span>
            </div>

            <div className={classes.divider} />

            <div className={classes.optionItem} onClick={onSelectFromLibrary}>
              <span className={classes.optionText}>{i18n('Library')}</span>
            </div>
          </div>

          <div className={classes.cancelContainer}>
            <div className={classes.cancelButton} onClick={onClose}>
              <span className={classes.cancelText}>{i18n('Cancel')}</span>
            </div>
          </div>
        </div>
      </Drawer>
    )
  } else {
    return (
      <FOModal visible={visible} setVisible={onClose} center={true}>
        <div className={classes.container}>
          <img
            src={cancelIcon}
            alt='cancel'
            className={classes.cancelIcon}
            onClick={onClose}
          />
          <div style={{ paddingTop: '40px' }}>
            <div className={classes.buttonDesktop} onClick={onTakePhoto}>
              <span>Take photo</span>
            </div>

            <div
              className={classes.buttonDesktop}
              onClick={onSelectFromLibrary}
              style={{ marginTop: '16px' }}
            >
              <span>Library</span>
            </div>
          </div>
        </div>
      </FOModal>
    )
  }
}

export default TakePhoneDrawer
